var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#434DF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5v1h1v3a2 2 0 1 1-4 0V6h1V5h-2v4a3.002 3.002 0 0 0 2.5 2.955V15a3 3 0 0 1-6 0v-3.071a2 2 0 1 0-1 0V15a4 4 0 1 0 8 0v-3.045A3.003 3.003 0 0 0 18 9V5h-2zm-9 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorActiveIcon);
export default __webpack_public_path__ + "static/media/doctorActiveIcon.5acc40feb7613d1fc5ecd4a3dce4911c.svg";
export { ForwardRef as ReactComponent };